import { Participant, ParticipantState } from '../../pages/call/types';
import { SELF } from '../constants';

export function sortParticipants<T extends Participant | ParticipantState>(participants: T[]): T[] {
    return participants
        .filter(({ id }) => id === SELF)
        .concat(participants.filter(({ id, isLocalRecording }) => isLocalRecording && id !== SELF))
        .concat(participants.filter(({ id, isLocalRecording }) => !isLocalRecording && id !== SELF))
        .sort((a, b) => {
            if (a.id === SELF) {
                return -1;
            } else if (b.id === SELF) {
                return 1;
            }

            const aHasHand = a.reaction?.reactionType === 'hand';
            const bHasHand = b.reaction?.reactionType === 'hand';

            if (aHasHand && !bHasHand) {
                return -1;
            } else if (!aHasHand && bHasHand) {
                return 1;
            } else if (aHasHand && bHasHand) {
                const aTimestamp = a.reaction?.timestamp || Infinity;
                const bTimestamp = b.reaction?.timestamp || Infinity;

                const result = aTimestamp - bTimestamp;

                return Number.isNaN(result) ? 0 : result;
            } else {
                return 0;
            }
        });
}
